import React, { useCallback, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { RefreshCw } from "lucide-react";
import ListPageTemplate from "../common/ListPageTemplate";
import { listAuditEvents } from "../../api/studioAPI";
import { useProfile, isOwner } from "../../context/ProfileContext";
import { describe, when } from "../Dashboard";
import { colors, surfaces, buttons } from "../../styles/index";

const ACTIONS = ["ALL", "CREATE", "DELETE", "PUBLISH", "UNPUBLISH", "INVITE", "JOIN", "ROLE", "REMOVE", "UPDATE"];

// The org's audit trail (logistics-workflow's audit page, for this app's events): owners see everyone's actions, a creator
// their own.
export default function AuditTrailList() {
  const { profile } = useProfile();
  const [events, setEvents] = useState(null);
  const [action, setAction] = useState("ALL");

  const load = useCallback(() => {
    setEvents(null);
    listAuditEvents(300).then((d) => setEvents(d.items)).catch((e) => { toast.error(e.message); setEvents([]); });
  }, []);
  useEffect(() => { load(); }, [load]);

  const shown = (events || []).filter((e) => action === "ALL" || e.action === action);

  return (
    <ListPageTemplate
      title="Audit"
      actions={<button type="button" style={buttons.secondary} onClick={load} title="Refresh"><RefreshCw size={16} /> Refresh</button>}
      filters={
        <div style={{ display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap" }}>
          <label style={{ fontSize: "0.9rem" }}>
            Action{" "}
            <select value={action} onChange={(e) => setAction(e.target.value)} style={{ padding: "6px 8px", borderRadius: 6 }}>
              {ACTIONS.map((a) => <option key={a} value={a}>{a === "ALL" ? "All" : a.toLowerCase()}</option>)}
            </select>
          </label>
          <span style={{ fontSize: "0.85rem", color: colors.textMuted }}>
            {isOwner(profile) ? "Everything done in your organization." : "What you've done. Owners see everyone's actions."}
          </span>
        </div>
      }
      loading={events === null}
      empty={events !== null && shown.length === 0}
      emptyIcon="🗒️"
      emptyTitle="Nothing here yet"
      emptyDescription="Plans made and deleted, games shared and members invited show up here."
    >
      <div style={{ ...surfaces.card, textAlign: "left", padding: 0 }}>
        {shown.map((e) => (
          <div key={`${e.at}-${e.entity_id}-${e.action}`} style={{ display: "flex", justifyContent: "space-between", gap: 12,
            padding: "10px 16px", borderBottom: `1px solid ${colors.border}`, flexWrap: "wrap", fontSize: "0.9rem" }}>
            <span style={{ flex: "1 1 280px" }}>
              {describe(e)}
              {e.summary && <span style={{ color: colors.textMuted }}> - {e.summary}</span>}
            </span>
            <span style={{ color: colors.textMuted }}>{when(e.at)}</span>
          </div>
        ))}
      </div>
    </ListPageTemplate>
  );
}
